
export default {
	name: 'common-view-result',
	mixins: [],
	extends: {},
	components: {},
	props: ['title'],
	data() {
		return {};
	},
	computed: {

	},
	watch: {},
	created() {},
	mounted() {
        this.init();
    },
	updated() {},
	beforeDestroy() {},
	methods: {
        async init(){
            if(!this.title){
                this.$router.push('.');
            }
        }
    },
};



// WEBPACK FOOTER //
// ./src/components/basicSetting/commonView/commonViewResult.js